var Be = Object.defineProperty;
var pe = (r) => {
  throw TypeError(r);
};
var $e = (r, e, t) => e in r ? Be(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var L = (r, e, t) => $e(r, typeof e != "symbol" ? e + "" : e, t), oe = (r, e, t) => e.has(r) || pe("Cannot " + t);
var b = (r, e, t) => (oe(r, e, "read from private field"), t ? t.call(r) : e.get(r)), S = (r, e, t) => e.has(r) ? pe("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(r) : e.set(r, t), Z = (r, e, t, n) => (oe(r, e, "write to private field"), n ? n.call(r, t) : e.set(r, t), t), y = (r, e, t) => (oe(r, e, "access private method"), t);
import { jsx as v, Fragment as te, jsxs as ce } from "react/jsx-runtime";
import re, { useRef as B, useImperativeHandle as Ke, useMemo as z, useCallback as Ze, useEffect as H, useState as Ae, useDebugValue as Xe, memo as Je } from "react";
const fe = {
  PREFERRED_FRAME_SIZE: "preferred-frame-size",
  INITIAL_RENDER_DATA: "initial-render-data"
}, he = "mcpui.dev/ui-";
function Qe(r) {
  let e;
  try {
    e = new URL(r);
  } catch (t) {
    return console.error("Error parsing URL:", t), !1;
  }
  return e.protocol === "http:" || e.protocol === "https:";
}
function et(r, e) {
  if (r.mimeType !== "text/html" && r.mimeType !== "text/uri-list")
    return {
      error: "Resource must be of type text/html (for HTML content) or text/uri-list (for URL content)."
    };
  if (r.mimeType === "text/uri-list") {
    let t = "";
    if ("text" in r && typeof r.text == "string" && r.text.trim() !== "")
      t = r.text;
    else if ("blob" in r && typeof r.blob == "string")
      try {
        t = new TextDecoder().decode(
          Uint8Array.from(atob(r.blob), (o) => o.charCodeAt(0))
        );
      } catch (o) {
        return console.error("Error decoding base64 blob for URL content:", o), {
          error: "Error decoding URL from blob."
        };
      }
    else
      return {
        error: "URL resource expects a non-empty text or blob field containing the URL."
      };
    if (t.trim() === "")
      return {
        error: "URL content is empty."
      };
    const n = t.split(`
`).map((o) => o.trim()).filter((o) => o && !o.startsWith("#") && Qe(o));
    if (n.length === 0)
      return {
        error: "No valid URLs found in uri-list content."
      };
    n.length > 1 && console.warn(
      `Multiple URLs found in uri-list content. Using the first URL: "${n[0]}". Other URLs ignored:`,
      n.slice(1)
    );
    const s = n[0];
    if (e && e.trim() !== "")
      try {
        const o = new URL(e);
        if (typeof window < "u" && o.host === window.location.host)
          console.error(
            "For security, the proxy origin must not be the same as the host origin. Using original URL instead."
          );
        else
          return o.searchParams.set("url", s), {
            iframeSrc: o.toString(),
            iframeRenderMode: "src"
          };
      } catch (o) {
        console.error(
          `Invalid proxy URL provided: "${e}". Falling back to direct URL.`,
          o instanceof Error ? o.message : String(o)
        );
      }
    return {
      iframeSrc: s,
      iframeRenderMode: "src"
    };
  } else if (r.mimeType === "text/html") {
    let t = "";
    if ("text" in r && typeof r.text == "string")
      t = r.text;
    else if ("blob" in r && typeof r.blob == "string")
      try {
        t = new TextDecoder().decode(
          Uint8Array.from(atob(r.blob), (n) => n.charCodeAt(0))
        );
      } catch (n) {
        return console.error("Error decoding base64 blob for HTML content:", n), {
          error: "Error decoding HTML content from blob."
        };
      }
    else
      return {
        error: "HTML resource requires text or blob content."
      };
    if (e && e.trim() !== "")
      try {
        const n = new URL(e);
        if (typeof window < "u" && n.host === window.location.host)
          console.error(
            "For security, the proxy origin must not be the same as the host origin. Using srcDoc rendering instead."
          );
        else
          return n.searchParams.set("contentType", "rawhtml"), {
            iframeSrc: n.toString(),
            iframeRenderMode: "src",
            htmlString: t
            // Pass HTML so it can be sent to the proxy via postMessage
          };
      } catch (n) {
        console.error(
          `Invalid proxy URL provided: "${e}". Falling back to srcDoc rendering.`,
          n instanceof Error ? n.message : String(n)
        );
      }
    return {
      htmlString: t,
      iframeRenderMode: "srcDoc"
    };
  } else
    return {
      error: "Unsupported mimeType. Expected text/html or text/uri-list."
    };
}
function tt(r) {
  if ("text" in r && typeof r.text == "string" && r.text.trim() !== "")
    return {
      code: r.text
    };
  if ("blob" in r && typeof r.blob == "string")
    try {
      return {
        code: new TextDecoder().decode(
          Uint8Array.from(atob(r.blob), (t) => t.charCodeAt(0))
        )
      };
    } catch (e) {
      return console.error("Error decoding base64 blob for remote DOM content:", e), {
        error: "Error decoding remote DOM content from blob."
      };
    }
  return {
    error: "Remote DOM resource requires non-empty text or blob content."
  };
}
function rt(r) {
  return r._meta ?? {};
}
function nt(r) {
  const e = rt(r), t = {};
  return Object.entries(e).forEach(([n, s]) => {
    n.startsWith(he) && (t[n.slice(he.length)] = s);
  }), t;
}
const A = {
  UI_MESSAGE_RECEIVED: "ui-message-received",
  UI_MESSAGE_RESPONSE: "ui-message-response",
  UI_SIZE_CHANGE: "ui-size-change",
  UI_LIFECYCLE_IFRAME_READY: "ui-lifecycle-iframe-ready",
  UI_LIFECYCLE_IFRAME_RENDER_DATA: "ui-lifecycle-iframe-render-data",
  UI_REQUEST_RENDER_DATA: "ui-request-render-data",
  // Proxy-only lifecycle for outer iframe (distinct from widget readiness)
  UI_PROXY_IFRAME_READY: "ui-proxy-iframe-ready",
  // Content transport for raw HTML when using proxy
  UI_HTML_CONTENT: "ui-html-content"
}, ot = {
  WAIT_FOR_RENDER_DATA: "waitForRenderData"
}, Ne = ({
  resource: r,
  onUIAction: e,
  style: t,
  proxy: n,
  iframeRenderData: s,
  autoResizeIframe: o,
  sandboxPermissions: a,
  iframeProps: u
}) => {
  const l = B(null);
  Ke(u == null ? void 0 : u.ref, () => l.current);
  const { error: f, iframeSrc: i, iframeRenderMode: m, htmlString: d } = z(
    () => et(r, n),
    [r, n]
  ), c = z(() => nt(r), [r]), p = c[fe.PREFERRED_FRAME_SIZE] ?? ["100%", "100%"], h = c[fe.INITIAL_RENDER_DATA] ?? void 0, E = z(() => {
    if (!(!s && !h))
      return {
        ...h,
        ...s
      };
  }, [s, h]), _ = z(() => {
    if (i && E) {
      const T = new URL(i);
      return T.searchParams.set(ot.WAIT_FOR_RENDER_DATA, "true"), T.toString();
    }
    return i;
  }, [i, E]), R = Ze(
    (T) => {
      var j;
      if (E) {
        const I = T.currentTarget.contentWindow, P = _ ? new URL(_).origin : "*";
        U(
          A.UI_LIFECYCLE_IFRAME_RENDER_DATA,
          I,
          P,
          void 0,
          {
            renderData: E
          }
        );
      }
      (j = u == null ? void 0 : u.onLoad) == null || j.call(u, T);
    },
    [E, _, u == null ? void 0 : u.onLoad]
  ), N = z(() => m === "srcDoc" ? _e(a ?? "", "allow-scripts") : _e(a ?? "", "allow-scripts allow-same-origin"), [a, m]);
  return H(() => {
    async function T(j) {
      const { source: I, origin: P, data: g } = j;
      if (l.current && I === l.current.contentWindow) {
        if ((g == null ? void 0 : g.type) === A.UI_PROXY_IFRAME_READY) {
          m === "src" && d && (_ != null && _.includes("contentType=rawhtml")) && U(A.UI_HTML_CONTENT, I, P, void 0, {
            html: d
          });
          return;
        }
        if ((g == null ? void 0 : g.type) === A.UI_LIFECYCLE_IFRAME_READY) {
          E && U(
            A.UI_LIFECYCLE_IFRAME_RENDER_DATA,
            I,
            P,
            void 0,
            {
              renderData: E
            }
          );
          return;
        }
        if ((g == null ? void 0 : g.type) === A.UI_REQUEST_RENDER_DATA) {
          U(
            A.UI_LIFECYCLE_IFRAME_RENDER_DATA,
            I,
            P,
            g.messageId,
            {
              renderData: E
            }
          );
          return;
        }
        if ((g == null ? void 0 : g.type) === A.UI_SIZE_CHANGE) {
          const { width: F, height: C } = g.payload;
          if (o && l.current) {
            const He = (typeof o == "boolean" || o.height) && C, qe = (typeof o == "boolean" || o.width) && F;
            He && (l.current.style.height = `${C}px`), qe && (l.current.style.width = `${F}px`);
          }
          return;
        }
        const ne = g;
        if (!ne)
          return;
        if (e) {
          const F = ne.messageId;
          U(A.UI_MESSAGE_RECEIVED, I, P, F);
          try {
            const C = await e(ne);
            U(A.UI_MESSAGE_RESPONSE, I, P, F, {
              response: C
            });
          } catch (C) {
            console.error("Error handling UI action result in HTMLResourceRenderer:", C), U(A.UI_MESSAGE_RESPONSE, I, P, F, {
              error: C
            });
          }
        }
      }
    }
    return window.addEventListener("message", T), () => window.removeEventListener("message", T);
  }, [e, E, m, d, _]), f ? /* @__PURE__ */ v("p", { className: "text-red-500", children: f }) : m === "srcDoc" ? d == null ? f ? null : /* @__PURE__ */ v("p", { className: "text-orange-500", children: "No HTML content to display." }) : /* @__PURE__ */ v(
    "iframe",
    {
      srcDoc: d,
      sandbox: N,
      style: { width: p[0], height: p[1], ...t },
      title: "MCP HTML Resource (Embedded Content)",
      ...u,
      ref: l,
      onLoad: R
    }
  ) : m === "src" ? _ == null ? f ? null : /* @__PURE__ */ v("p", { className: "text-orange-500", children: "No URL provided for HTML resource." }) : /* @__PURE__ */ v(
    "iframe",
    {
      src: _,
      sandbox: N,
      style: { width: p[0], height: p[1], ...t },
      title: "MCP HTML Resource (URL)",
      ...u,
      ref: l,
      onLoad: R
    }
  ) : /* @__PURE__ */ v("p", { className: "text-gray-500", children: "Initializing HTML resource display..." });
};
Ne.displayName = "HTMLResourceRenderer";
function U(r, e, t, n, s) {
  const o = t && t !== "null" ? t : "*";
  e == null || e.postMessage(
    {
      type: r,
      messageId: n ?? void 0,
      payload: s
    },
    o
  );
}
function _e(r, e) {
  return [.../* @__PURE__ */ new Set([...r.split(" "), ...e.split(" ")])].filter(Boolean).map((t) => t.trim()).join(" ");
}
const Ie = 1, Pe = 3, Oe = 8, it = 9, st = 0, at = 1, lt = 2, ct = 3, $ = 1, de = 2, ue = 3, q = "~";
function De({
  call: r,
  insertChild: e,
  removeChild: t,
  updateText: n,
  updateProperty: s
}) {
  const o = {
    [st]: e,
    [at]: t,
    [lt]: n,
    [ct]: s
  };
  return {
    call: r,
    mutate(a) {
      for (const [u, ...l] of a)
        o[u](...l);
    }
  };
}
class dt {
  constructor({
    retain: e,
    release: t,
    methods: n
  } = {}) {
    /**
     * Represents the root node of the remote tree. This node is always defined,
     * and you will likely be most interested in its `children` property, which
     * contains the top-level elements of the remote tree.
     */
    L(this, "root", {
      id: q,
      type: it,
      children: [],
      version: 0,
      properties: {},
      attributes: {},
      eventListeners: {}
    });
    /**
     * An object that can synchronize a tree of elements between two JavaScript
     * environments. This object acts as a “thin waist”, allowing for efficient
     * communication of changes between a “remote” environment (usually, a JavaScript
     * sandbox, such as an `iframe` or Web Worker) and a “host” environment
     * (usually, a top-level browser page).
     */
    L(this, "attached", /* @__PURE__ */ new Map([[q, this.root]]));
    L(this, "subscribers", /* @__PURE__ */ new Map());
    L(this, "parents", /* @__PURE__ */ new Map());
    L(this, "implementations", /* @__PURE__ */ new Map());
    const {
      attached: s,
      parents: o,
      subscribers: a
    } = this;
    this.connection = De({
      call: (i, m, ...d) => {
        const c = this.implementations.get(i), p = c == null ? void 0 : c[m];
        if (typeof p != "function")
          throw new Error(`Node ${i} does not implement the ${m}() method`);
        return p(...d);
      },
      insertChild: (i, m, d) => {
        const c = s.get(i), {
          children: p
        } = c, h = l(m, c);
        d === p.length ? p.push(h) : p.splice(d, 0, h), c.version += 1, this.parents.set(m.id, c.id), u(c);
      },
      removeChild: (i, m) => {
        const d = s.get(i), {
          children: c
        } = d, [p] = c.splice(m, 1);
        p && (d.version += 1, u(d), f(p));
      },
      updateProperty: (i, m, d, c = $) => {
        const p = s.get(i);
        e == null || e(d);
        let h;
        switch (c) {
          case $:
            h = p.properties;
            break;
          case de:
            h = p.attributes;
            break;
          case ue:
            h = p.eventListeners;
            break;
        }
        const E = h[m];
        h[m] = d, p.version += 1;
        let _;
        if (m === "slot") {
          const R = this.parents.get(i);
          _ = R == null ? R : s.get(R), _ && (_.version += 1);
        }
        u(p), _ && u(_), t == null || t(E);
      },
      updateText: (i, m) => {
        const d = s.get(i);
        d.data = m, d.version += 1, u(d);
      }
    }), n && this.implement(this.root, n);
    function u(i) {
      const m = a.get(i.id);
      if (m)
        for (const d of m)
          d(i);
    }
    function l(i, m) {
      let d;
      switch (i.type) {
        case Pe:
        case Oe: {
          const {
            id: c,
            type: p,
            data: h
          } = i;
          d = {
            id: c,
            type: p,
            data: h,
            version: 0
          };
          break;
        }
        case Ie: {
          const {
            id: c,
            type: p,
            element: h,
            children: E,
            properties: _,
            attributes: R,
            eventListeners: N
          } = i;
          e == null || e(_), e == null || e(N);
          const T = [];
          d = {
            id: c,
            type: p,
            element: h,
            version: 0,
            children: T,
            properties: {
              ..._
            },
            attributes: {
              ...R
            },
            eventListeners: {
              ...N
            }
          };
          for (const j of E)
            T.push(l(j, d));
          break;
        }
        default:
          throw new Error(`Unknown node type: ${JSON.stringify(i)}`);
      }
      return s.set(d.id, d), o.set(d.id, m.id), d;
    }
    function f(i) {
      if (s.delete(i.id), o.delete(i.id), t && ("properties" in i && t(i.properties), "eventListeners" in i && t(i.eventListeners)), "children" in i)
        for (const m of i.children)
          f(m);
    }
  }
  /**
   * Fetches the latest state of a remote element that has been
   * received from the remote environment.
   *
   * @param node The remote node to fetch.
   * @returns The current state of the remote node, or `undefined` if the node is not connected to the remote tree.
   *
   * @example
   * import {RemoteReceiver} from '@remote-dom/core/receivers';
   *
   * const receiver = new RemoteReceiver();
   *
   * receiver.get(receiver.root) === receiver.root; // true
   */
  get({
    id: e
  }) {
    return this.attached.get(e);
  }
  /**
   * Lets you define how [remote methods](https://github.com/Shopify/remote-dom/blob/main/packages/core#remotemethods)
   * are implemented for a particular element in the tree.
   *
   * @param node The remote node to subscribe for changes.
   * @param implementation A record containing the methods to expose for the passed node.
   *
   * @example
   * // In the host environment:
   * import {RemoteReceiver} from '@remote-dom/core/receivers';
   *
   * const receiver = new RemoteReceiver();
   *
   * receiver.implement(receiver.root, {
   *   alert(message) {
   *     window.alert(message);
   *   },
   * });
   *
   * // In the remote environment:
   * import {RemoteRootElement} from '@remote-dom/core/elements';
   *
   * customElements.define('remote-root', RemoteRootElement);
   *
   * const root = document.createElement('remote-root');
   * root.connect(receiver.connection);
   *
   * root.callRemoteMethod('alert', 'Hello, world!');
   */
  implement({
    id: e
  }, t) {
    t == null ? this.implementations.delete(e) : this.implementations.set(e, t);
  }
  /**
   * Allows you to subscribe to changes in a remote element. This includes
   * changes to the remote element’s properties and list of children, but
   * note that you will not receive updates for properties or children of
   * _nested_ elements.
   *
   * @param node The remote node to subscribe for changes.
   * @param subscriber A function that will be called with the updated node on each change.
   *
   * @example
   * import {RemoteReceiver} from '@remote-dom/core/receivers';
   *
   * const abort = new AbortController();
   * const receiver = new RemoteReceiver();
   *
   * // Subscribe to all changes in the top-level children, attached
   * // directly to the remote “root”.
   * receiver.subscribe(
   *   receiver.root,
   *   (root) => {
   *     console.log('Root changed!', root);
   *   },
   *   {signal: abort.signal},
   * );
   */
  subscribe({
    id: e
  }, t, {
    signal: n
  } = {}) {
    let s = this.subscribers.get(e);
    s == null && (s = /* @__PURE__ */ new Set(), this.subscribers.set(e, s)), s.add(t), n == null || n.addEventListener("abort", () => {
      s.delete(t), s.size === 0 && this.subscribers.delete(e);
    });
  }
}
const Ee = /* @__PURE__ */ new WeakMap(), X = /* @__PURE__ */ new WeakMap(), Ce = /* @__PURE__ */ new WeakMap();
class ut {
  constructor({
    root: e,
    retain: t,
    release: n,
    call: s,
    cache: o
  } = {}) {
    /**
     * The root element that will contain the host implementations of
     * all nodes attached to the remote tree. To connect the receiver to
     * a new element, call the `connect()` method.
     */
    /**
     * An object that can synchronize a tree of elements between two JavaScript
     * environments. This object acts as a “thin waist”, allowing for efficient
     * communication of changes between a “remote” environment (usually, a JavaScript
     * sandbox, such as an `iframe` or Web Worker) and a “host” environment
     * (usually, a top-level browser page).
     */
    L(this, "attached", /* @__PURE__ */ new Map());
    this.root = e ?? document.createDocumentFragment();
    const {
      attached: a
    } = this, u = /* @__PURE__ */ new Map();
    this.connection = De({
      call: (i, m, ...d) => {
        const c = i === q && this.root.nodeType !== 11 ? this.root : a.get(i);
        return s ? s(c, m, ...d) : c[m](...d);
      },
      insertChild: (i, m, d) => {
        const c = i === q ? this.root : a.get(i), p = u.get(i);
        p && clearTimeout(p), c.insertBefore(l(m), c.childNodes[d] || null);
      },
      removeChild: (i, m) => {
        const c = (i === q ? this.root : a.get(i)).childNodes[m];
        if (c.remove(), o != null && o.maxAge) {
          const p = u.get(i);
          p && clearTimeout(p);
          const h = setTimeout(() => {
            f(c);
          }, o.maxAge);
          u.set(i, h);
        } else
          f(c);
      },
      updateProperty: (i, m, d, c = $) => {
        const p = a.get(i);
        t == null || t(d);
        const h = X.get(p), E = h[m];
        h[m] = d, J(p, m, d, c), n == null || n(E);
      },
      updateText: (i, m) => {
        const d = a.get(i);
        d.data = m;
      }
    });
    function l(i) {
      const m = a.get(i.id);
      if (m) return m;
      let d;
      switch (i.type) {
        case Ie: {
          if (d = document.createElement(i.element), i.properties) {
            X.set(d, i.properties);
            for (const c of Object.keys(i.properties)) {
              const p = i.properties[c];
              t == null || t(p), J(d, c, p, $);
            }
          } else
            X.set(d, {});
          if (i.attributes)
            for (const c of Object.keys(i.attributes)) {
              const p = i.attributes[c];
              t == null || t(p), J(d, c, p, de);
            }
          if (Ce.set(d, {}), i.eventListeners)
            for (const c of Object.keys(i.eventListeners)) {
              const p = i.eventListeners[c];
              t == null || t(p), J(d, c, p, ue);
            }
          for (const c of i.children)
            d.appendChild(l(c));
          break;
        }
        case Pe: {
          d = document.createTextNode(i.data);
          break;
        }
        case Oe: {
          d = document.createComment(i.data);
          break;
        }
        default:
          throw new Error(`Unknown node type: ${JSON.stringify(i)}`);
      }
      return Ee.set(d, i.id), a.set(i.id, d), d;
    }
    function f(i) {
      const m = Ee.get(i);
      m && a.delete(m);
      const d = X.get(i);
      if (d && n && n(d), i instanceof Element)
        for (const c of i.childNodes)
          f(c);
    }
  }
  /**
   * Connects the receiver to a new root element. The representation of
   * any child elements of the remote root will be appended to this node
   * as children, and the `root` property will be updated to point to the
   * new element.
   */
  connect(e) {
    const t = this.root;
    this.root = e, t.childNodes.forEach((n) => {
      e.appendChild(n);
    });
  }
  /**
   * Disconnects the receiver from its current root element. Any current
   * children of the root element will be moved to a `DocumentFragment`
   * instead, so they can be re-attached to a new element later.
   */
  disconnect() {
    if (this.root.nodeType === 11) return this.root;
    const e = this.root, t = new DocumentFragment();
    return this.root = t, e.childNodes.forEach((n) => {
      t.appendChild(n);
    }), t;
  }
}
function J(r, e, t, n) {
  switch (n) {
    case $: {
      r[e] = t;
      break;
    }
    case de: {
      t == null ? r.removeAttribute(e) : r.setAttribute(e, t);
      break;
    }
    case ue: {
      const s = Ce.get(r), o = s == null ? void 0 : s[e];
      if (o && r.removeEventListener(e, o), t != null) {
        const a = (u) => {
          var f;
          if (u.target !== r) return;
          const l = t(u.detail);
          (f = u.resolve) == null || f.call(u, l);
        };
        s && (s[e] = a), r.addEventListener(e, a);
      }
      break;
    }
  }
}
function me(r, e) {
  const [t, n] = Ae(() => {
    const o = e.get(r);
    return {
      id: r.id,
      version: o == null ? void 0 : o.version,
      value: o,
      receiver: e
    };
  });
  let s = t.value;
  if (t.receiver !== e || t.id !== r.id) {
    const o = e.get(r);
    s = o, n({
      receiver: e,
      id: r.id,
      version: o == null ? void 0 : o.version,
      value: s
    });
  }
  return Xe(s), H(() => {
    const o = new AbortController(), a = () => {
      o.signal.aborted || n((u) => {
        const {
          id: l,
          version: f,
          receiver: i
        } = u, {
          id: m
        } = r;
        if (i !== e || l !== m)
          return u;
        const d = e.get(r), c = d == null ? void 0 : d.version;
        return f === c ? u : {
          receiver: e,
          value: d,
          id: m,
          version: c
        };
      });
    };
    return e.subscribe(r, a, {
      signal: o.signal
    }), a(), () => {
      o.abort();
    };
  }, [e, r.id]), s;
}
function mt({
  remote: r,
  receiver: e
}) {
  const t = me(r, e);
  return t ? /* @__PURE__ */ v(te, {
    children: t.data
  }) : null;
}
function se(r, {
  receiver: e,
  components: t
}) {
  switch (r.type) {
    case 1: {
      const n = t.get(r.element);
      if (n == null)
        throw new Error(`No component found for remote element: ${r.element}`);
      return /* @__PURE__ */ v(n, {
        element: r,
        receiver: e,
        components: t
      }, r.id);
    }
    case 3:
      return /* @__PURE__ */ v(mt, {
        remote: r,
        receiver: e
      }, r.id);
    case 8:
      return null;
    default:
      throw new Error(`Unknown remote node type: ${String(r)}`);
  }
}
function pt(r, e) {
  if (!r) return;
  const {
    children: t,
    properties: n,
    attributes: s,
    eventListeners: o
  } = r, a = [], u = {
    ...n,
    ...s,
    children: a
  };
  if (e.eventProps)
    for (const [l, f] of Object.entries(e.eventProps)) {
      const i = f == null ? void 0 : f.event;
      if (i == null) continue;
      const m = o[i];
      m && (u[l] = be(m));
    }
  else
    for (const [l, f] of Object.entries(o))
      u[`on${l[0].toUpperCase()}${l.slice(1)}`] = be(f);
  for (const l of t)
    if (l.type === 1 && typeof l.attributes.slot == "string") {
      const f = l.attributes.slot, i = se(l, e);
      u[f] = u[f] ? /* @__PURE__ */ ce(te, {
        children: [u[f], i]
      }) : i;
    } else
      a.push(se(l, e));
  return u;
}
function be(r) {
  return function(...t) {
    if (t.length === 1 && t[0] instanceof Event) {
      const n = t[0];
      return n.target !== n.currentTarget ? void 0 : "detail" in n ? r(n.detail) : r();
    }
    return r(...t);
  };
}
const ft = Symbol.for("remote-dom.element"), ht = Symbol.for("remote-dom.element.attached");
function _t(r, {
  name: e,
  eventProps: t
} = {}) {
  const n = /* @__PURE__ */ Je(function({
    element: o,
    receiver: a,
    components: u
  }) {
    const l = B(), f = me(o, a), i = f ?? o, m = i.id, d = pt(i, {
      receiver: a,
      components: u,
      eventProps: t
    });
    if (d[ft] = i, d[ht] = f != null, l.current == null) {
      const c = {
        id: m,
        receiver: a
      };
      c.instanceRef = Et(c), l.current = c;
    }
    return l.current.id = m, l.current.receiver = a, H(() => {
      var p;
      const c = {
        id: m
      };
      return a.implement(c, (p = l.current) == null ? void 0 : p.instanceRef.current), () => {
        a.implement(c, null);
      };
    }, [m, a]), /* @__PURE__ */ v(r, {
      ref: l.current.instanceRef,
      ...d
    });
  });
  return n.displayName = e ?? `RemoteComponentRenderer(${r.displayName ?? r.name ?? "Component"})`, n;
}
function Et(r) {
  let e = null;
  return {
    get current() {
      return e;
    },
    set current(t) {
      e = t, r.receiver.implement(r, t);
    }
  };
}
function bt(r) {
  const {
    receiver: e
  } = r, {
    children: t
  } = me(e.root, e);
  return /* @__PURE__ */ v(te, {
    children: t.map((n) => se(n, r))
  });
}
const vt = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
</head>
<body>
  <div id="root"></div>
  <script>
"use strict";
(() => {
  var __defProp = Object.defineProperty;
  var __typeError = (msg) => {
    throw TypeError(msg);
  };
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
  var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
  var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
  var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
  var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

  // ../../../node_modules/.pnpm/@remote-dom+core@1.8.1_@preact+signals-core@1.10.0/node_modules/@remote-dom/core/build/esm/elements/RemoteEvent.mjs
  var RemoteEvent = class extends CustomEvent {
    /**
     * The last value received from a \`respondWith()\` call.
     */
    /**
     * Provides the \`response\` value to be sent as the return value for
     * the remote property function that triggered this event.
     */
    respondWith(response) {
      this.response = response;
    }
  };

  // ../../../node_modules/.pnpm/@remote-dom+core@1.8.1_@preact+signals-core@1.10.0/node_modules/@remote-dom/core/build/esm/constants.mjs
  var MUTATION_TYPE_INSERT_CHILD = 0;
  var MUTATION_TYPE_REMOVE_CHILD = 1;
  var MUTATION_TYPE_UPDATE_TEXT = 2;
  var MUTATION_TYPE_UPDATE_PROPERTY = 3;
  var UPDATE_PROPERTY_TYPE_PROPERTY = 1;
  var UPDATE_PROPERTY_TYPE_ATTRIBUTE = 2;
  var UPDATE_PROPERTY_TYPE_EVENT_LISTENER = 3;
  var ROOT_ID = "~";

  // ../../../node_modules/.pnpm/@remote-dom+core@1.8.1_@preact+signals-core@1.10.0/node_modules/@remote-dom/core/build/esm/elements/internals.mjs
  var REMOTE_CONNECTIONS = /* @__PURE__ */ new WeakMap();
  var REMOTE_IDS = /* @__PURE__ */ new WeakMap();
  var id = 0;
  function remoteId(node) {
    let remoteID = REMOTE_IDS.get(node);
    if (remoteID == null) {
      remoteID = String(id++);
      REMOTE_IDS.set(node, remoteID);
    }
    return remoteID;
  }
  var REMOTE_PROPERTIES = /* @__PURE__ */ new WeakMap();
  function remoteProperties(node) {
    return REMOTE_PROPERTIES.get(node);
  }
  var REMOTE_ATTRIBUTES = /* @__PURE__ */ new WeakMap();
  function remoteAttributes(node) {
    let attributes = REMOTE_ATTRIBUTES.get(node);
    if (attributes != null) return attributes;
    if (!(node instanceof Element) || node.tagName.includes("-")) return void 0;
    attributes = {};
    for (const {
      name,
      value
    } of node.attributes) {
      attributes[name] = value;
    }
    return attributes;
  }
  var REMOTE_EVENT_LISTENERS = /* @__PURE__ */ new WeakMap();
  function remoteEventListeners(node) {
    return REMOTE_EVENT_LISTENERS.get(node);
  }
  function updateRemoteElementProperty(node, property, value) {
    let properties = REMOTE_PROPERTIES.get(node);
    if (properties == null) {
      properties = {};
      REMOTE_PROPERTIES.set(node, properties);
    }
    if (properties[property] === value) return;
    properties[property] = value;
    const connection = REMOTE_CONNECTIONS.get(node);
    if (connection == null) return;
    connection.mutate([[MUTATION_TYPE_UPDATE_PROPERTY, remoteId(node), property, value, UPDATE_PROPERTY_TYPE_PROPERTY]]);
  }
  function updateRemoteElementAttribute(node, attribute, value) {
    let attributes = REMOTE_ATTRIBUTES.get(node);
    if (attributes == null) {
      attributes = {};
      REMOTE_ATTRIBUTES.set(node, attributes);
    }
    if (attributes[attribute] === value) return;
    if (value == null) {
      delete attributes[attribute];
    } else {
      attributes[attribute] = String(value);
    }
    const connection = REMOTE_CONNECTIONS.get(node);
    if (connection == null) return;
    connection.mutate([[MUTATION_TYPE_UPDATE_PROPERTY, remoteId(node), attribute, value, UPDATE_PROPERTY_TYPE_ATTRIBUTE]]);
  }
  function updateRemoteElementEventListener(node, event, listener) {
    let eventListeners = REMOTE_EVENT_LISTENERS.get(node);
    if (eventListeners == null) {
      eventListeners = {};
      REMOTE_EVENT_LISTENERS.set(node, eventListeners);
    }
    if (eventListeners[event] === listener) return;
    if (listener == null) {
      delete eventListeners[event];
    } else {
      eventListeners[event] = listener;
    }
    const connection = REMOTE_CONNECTIONS.get(node);
    if (connection == null) return;
    connection.mutate([[MUTATION_TYPE_UPDATE_PROPERTY, remoteId(node), event, listener, UPDATE_PROPERTY_TYPE_EVENT_LISTENER]]);
  }
  function connectRemoteNode(node, connection) {
    const existingConnection = REMOTE_CONNECTIONS.get(node);
    if (existingConnection === connection) return;
    REMOTE_CONNECTIONS.set(node, connection);
    if (node.childNodes) {
      for (let i = 0; i < node.childNodes.length; i++) {
        connectRemoteNode(node.childNodes[i], connection);
      }
    }
  }
  function disconnectRemoteNode(node) {
    const existingConnection = REMOTE_CONNECTIONS.get(node);
    if (existingConnection == null) return;
    REMOTE_CONNECTIONS.delete(node);
    if (node.childNodes) {
      for (let i = 0; i < node.childNodes.length; i++) {
        disconnectRemoteNode(node.childNodes[i]);
      }
    }
  }
  function serializeRemoteNode(node) {
    const {
      nodeType
    } = node;
    switch (nodeType) {
      // Element
      case 1: {
        return {
          id: remoteId(node),
          type: nodeType,
          element: node.localName,
          properties: cloneMaybeObject(remoteProperties(node)),
          attributes: cloneMaybeObject(remoteAttributes(node)),
          eventListeners: cloneMaybeObject(remoteEventListeners(node)),
          children: Array.from(node.childNodes).map(serializeRemoteNode)
        };
      }
      // TextNode
      case 3:
      // Comment
      // eslint-disable-next-line no-fallthrough
      case 8: {
        return {
          id: remoteId(node),
          type: nodeType,
          data: node.data
        };
      }
      default: {
        throw new Error(\`Cannot serialize node of type \${node.nodeType} (\${typeof node.nodeType})\`);
      }
    }
  }
  function cloneMaybeObject(maybeObject) {
    return maybeObject ? {
      ...maybeObject
    } : void 0;
  }
  function callRemoteElementMethod(node, method, ...args) {
    const id2 = REMOTE_IDS.get(node);
    const connection = REMOTE_CONNECTIONS.get(node);
    if (id2 == null || connection == null) {
      throw new Error(\`Cannot call method \${method} on an unconnected node\`);
    }
    return connection.call(id2, method, ...args);
  }

  // ../../../node_modules/.pnpm/@remote-dom+core@1.8.1_@preact+signals-core@1.10.0/node_modules/@remote-dom/core/build/esm/elements/RemoteElement.mjs
  var EMPTY_DEFINITION = Object.freeze({});
  var RemoteElement = class extends HTMLElement {
    static get observedAttributes() {
      return this.finalize().__observedAttributes;
    }
    /**
     * The resolved property definitions for this remote element.
     */
    static get remotePropertyDefinitions() {
      return this.finalize().__remotePropertyDefinitions;
    }
    /**
     * The resolved attribute definitions for this remote element.
     */
    static get remoteAttributeDefinitions() {
      return this.finalize().__remoteAttributeDefinitions;
    }
    /**
     * The resolved event listener definitions for this remote element.
     */
    static get remoteEventDefinitions() {
      return this.finalize().__remoteEventDefinitions;
    }
    /**
     * The resolved slot definitions for this remote element.
     */
    static get remoteSlotDefinitions() {
      return this.finalize().__remoteSlotDefinitions;
    }
    /**
     * Creates a new definition for a property that will be synchronized between
     * this remote element and its host representation.
     */
    static createProperty(name, definition) {
      saveRemoteProperty(name, definition, this.observedAttributes, this.remotePropertyDefinitions, this.__attributeToPropertyMap, this.__eventToPropertyMap);
    }
    /**
     * Consumes all the static members defined on the class and converts them
     * into the internal representation used to handle properties, attributes,
     * and event listeners.
     */
    static finalize() {
      if (this.hasOwnProperty("__finalized")) {
        return this;
      }
      this.__finalized = true;
      const {
        slottable,
        remoteSlots,
        remoteProperties: remoteProperties2,
        remoteAttributes: remoteAttributes2,
        remoteEvents,
        remoteMethods
      } = this;
      const SuperConstructor = Object.getPrototypeOf(this);
      const observedAttributes = /* @__PURE__ */ new Set();
      if (slottable) observedAttributes.add("slot");
      const attributeToPropertyMap = /* @__PURE__ */ new Map();
      const eventToPropertyMap = /* @__PURE__ */ new Map();
      const remoteSlotDefinitions = /* @__PURE__ */ new Map();
      const remotePropertyDefinitions = /* @__PURE__ */ new Map();
      const remoteAttributeDefinitions = /* @__PURE__ */ new Map();
      const remoteEventDefinitions = /* @__PURE__ */ new Map();
      if (typeof SuperConstructor.finalize === "function") {
        SuperConstructor.finalize();
        SuperConstructor.observedAttributes.forEach((attribute) => {
          observedAttributes.add(attribute);
        });
        SuperConstructor.remotePropertyDefinitions.forEach((definition, property) => {
          remotePropertyDefinitions.set(property, definition);
        });
        SuperConstructor.remoteAttributeDefinitions.forEach((definition, event) => {
          remoteAttributeDefinitions.set(event, definition);
        });
        SuperConstructor.remoteEventDefinitions.forEach((definition, event) => {
          remoteEventDefinitions.set(event, definition);
        });
        SuperConstructor.remoteSlotDefinitions.forEach((definition, slot) => {
          remoteSlotDefinitions.set(slot, definition);
        });
      }
      if (remoteSlots != null) {
        const slotNames = Array.isArray(remoteSlots) ? remoteSlots : Object.keys(remoteSlots);
        slotNames.forEach((slotName) => {
          remoteSlotDefinitions.set(slotName, EMPTY_DEFINITION);
        });
      }
      if (remoteProperties2 != null) {
        if (Array.isArray(remoteProperties2)) {
          remoteProperties2.forEach((propertyName) => {
            saveRemoteProperty(propertyName, void 0, observedAttributes, remotePropertyDefinitions, attributeToPropertyMap, eventToPropertyMap);
          });
        } else {
          Object.keys(remoteProperties2).forEach((propertyName) => {
            saveRemoteProperty(propertyName, remoteProperties2[propertyName], observedAttributes, remotePropertyDefinitions, attributeToPropertyMap, eventToPropertyMap);
          });
        }
      }
      if (remoteAttributes2 != null) {
        remoteAttributes2.forEach((attribute) => {
          remoteAttributeDefinitions.set(attribute, EMPTY_DEFINITION);
          observedAttributes.add(attribute);
        });
      }
      if (remoteEvents != null) {
        if (Array.isArray(remoteEvents)) {
          remoteEvents.forEach((event) => {
            remoteEventDefinitions.set(event, EMPTY_DEFINITION);
          });
        } else {
          Object.keys(remoteEvents).forEach((event) => {
            remoteEventDefinitions.set(event, remoteEvents[event]);
          });
        }
      }
      if (remoteMethods != null) {
        if (Array.isArray(remoteMethods)) {
          for (const method of remoteMethods) {
            this.prototype[method] = function(...args) {
              return this.callRemoteMethod(method, ...args);
            };
          }
        } else {
          Object.assign(this, remoteMethods);
        }
      }
      Object.defineProperties(this, {
        __observedAttributes: {
          value: [...observedAttributes],
          enumerable: false
        },
        __remoteSlotDefinitions: {
          value: remoteSlotDefinitions,
          enumerable: false
        },
        __remotePropertyDefinitions: {
          value: remotePropertyDefinitions,
          enumerable: false
        },
        __remoteAttributeDefinitions: {
          value: remoteAttributeDefinitions,
          enumerable: false
        },
        __remoteEventDefinitions: {
          value: remoteEventDefinitions,
          enumerable: false
        },
        __attributeToPropertyMap: {
          value: attributeToPropertyMap,
          enumerable: false
        },
        __eventToPropertyMap: {
          value: eventToPropertyMap,
          enumerable: false
        }
      });
      return this;
    }
    // Just need to use these types so TS doesn’t lose track of them.
    /** @internal */
    /** @internal */
    /** @internal */
    /** @internal */
    constructor() {
      super();
      this.constructor.finalize();
      const propertyDescriptors = {};
      const initialPropertiesToSet = {};
      const prototype = Object.getPrototypeOf(this);
      const ThisClass = this.constructor;
      for (const [property, description] of ThisClass.remotePropertyDefinitions.entries()) {
        const aliasedName = description.name;
        if (prototype.hasOwnProperty(property)) {
          continue;
        }
        if (property === aliasedName) {
          initialPropertiesToSet[property] = description.default;
        }
        const propertyDescriptor = {
          configurable: true,
          enumerable: property === aliasedName,
          get: () => {
            return remoteProperties(this)?.[aliasedName];
          },
          set: (value) => {
            updateRemoteElementProperty(this, aliasedName, value);
          }
        };
        propertyDescriptors[property] = propertyDescriptor;
      }
      for (const [event, definition] of ThisClass.remoteEventDefinitions.entries()) {
        const propertyFromDefinition = definition.property ?? true;
        if (!propertyFromDefinition) continue;
        const property = propertyFromDefinition === true ? \`on\${event}\` : propertyFromDefinition;
        propertyDescriptors[property] = {
          configurable: true,
          enumerable: true,
          get: () => {
            return getRemoteEvents(this).properties.get(property) ?? null;
          },
          set: (value) => {
            const remoteEvents = getRemoteEvents(this);
            const currentListener = remoteEvents.properties.get(property);
            if (typeof value === "function") {
              let handler = function(...args) {
                return value.call(this, ...args);
              };
              remoteEvents.properties.set(property, handler);
              this.addEventListener(event, handler);
            } else {
              remoteEvents.properties.delete(property);
            }
            if (currentListener) {
              this.removeEventListener(event, currentListener);
            }
          }
        };
      }
      Object.defineProperties(this, propertyDescriptors);
      Object.assign(this, initialPropertiesToSet);
    }
    attributeChangedCallback(attribute, _oldValue, newValue) {
      if (attribute === "slot" && this.constructor.slottable) {
        updateRemoteElementAttribute(this, attribute, newValue ? String(newValue) : void 0);
        return;
      }
      const {
        remotePropertyDefinitions,
        remoteAttributeDefinitions,
        __attributeToPropertyMap: attributeToPropertyMap
      } = this.constructor;
      if (remoteAttributeDefinitions.has(attribute)) {
        updateRemoteElementAttribute(this, attribute, newValue);
        return;
      }
      const property = attributeToPropertyMap.get(attribute);
      const propertyDefinition = property == null ? property : remotePropertyDefinitions.get(property);
      if (propertyDefinition == null) return;
      this[property] = convertAttributeValueToProperty(newValue, propertyDefinition.type);
    }
    connectedCallback() {
      for (const [event, descriptor] of this.constructor.remoteEventDefinitions.entries()) {
        if (descriptor.bubbles) {
          this.addEventListener(event, noopBubblesEventListener);
        }
      }
    }
    disconnectedCallback() {
      for (const [event, descriptor] of this.constructor.remoteEventDefinitions.entries()) {
        if (descriptor.bubbles) {
          this.removeEventListener(event, noopBubblesEventListener);
        }
      }
    }
    addEventListener(type, listener, options) {
      const {
        remoteEventDefinitions,
        __eventToPropertyMap: eventToPropertyMap
      } = this.constructor;
      const listenerDefinition = remoteEventDefinitions.get(type);
      const property = eventToPropertyMap.get(type);
      if (listenerDefinition == null && property == null) {
        return super.addEventListener(type, listener, options);
      }
      const remoteEvents = getRemoteEvents(this);
      const remoteEvent = getRemoteEventRecord.call(this, type, {
        property,
        definition: listenerDefinition
      });
      const normalizedListener = typeof options === "object" && options?.once ? (...args) => {
        const result = typeof listener === "object" ? listener.handleEvent(...args) : listener.call(this, ...args);
        removeRemoteListener.call(this, type, listener, listenerRecord);
        return result;
      } : listener;
      const listenerRecord = [normalizedListener, remoteEvent];
      remoteEvent.listeners.add(listener);
      remoteEvents.listeners.set(listener, listenerRecord);
      super.addEventListener(type, normalizedListener, options);
      if (typeof options === "object" && options.signal) {
        options.signal.addEventListener("abort", () => {
          removeRemoteListener.call(this, type, listener, listenerRecord);
        }, {
          once: true
        });
      }
      if (listenerDefinition) {
        updateRemoteElementEventListener(this, type, remoteEvent.dispatch);
      } else {
        updateRemoteElementProperty(this, property, remoteEvent.dispatch);
      }
    }
    removeEventListener(type, listener, options) {
      const listenerRecord = REMOTE_EVENTS.get(this)?.listeners.get(listener);
      const normalizedListener = listenerRecord ? listenerRecord[0] : listener;
      super.removeEventListener(type, normalizedListener, options);
      if (listenerRecord == null) return;
      removeRemoteListener.call(this, type, listener, listenerRecord);
    }
    /**
     * Updates a single remote property on an element node. If the element is
     * connected to a remote root, this function will also make a \`mutate()\` call
     * to communicate the change to the host.
     */
    updateRemoteProperty(name, value) {
      updateRemoteElementProperty(this, name, value);
    }
    /**
     * Updates a single remote attribute on an element node. If the element is
     * connected to a remote root, this function will also make a \`mutate()\` call
     * to communicate the change to the host.
     */
    updateRemoteAttribute(name, value) {
      updateRemoteElementAttribute(this, name, value);
    }
    /**
     * Performs a method through \`RemoteConnection.call()\`, using the remote ID and
     * connection for the provided node.
     */
    callRemoteMethod(method, ...args) {
      return callRemoteElementMethod(this, method, ...args);
    }
  };
  __publicField(RemoteElement, "slottable", true);
  __publicField(RemoteElement, "__finalized", true);
  __publicField(RemoteElement, "__observedAttributes", []);
  __publicField(RemoteElement, "__attributeToPropertyMap", /* @__PURE__ */ (() => /* @__PURE__ */ new Map())());
  __publicField(RemoteElement, "__eventToPropertyMap", /* @__PURE__ */ (() => /* @__PURE__ */ new Map())());
  __publicField(RemoteElement, "__remotePropertyDefinitions", /* @__PURE__ */ (() => /* @__PURE__ */ new Map())());
  __publicField(RemoteElement, "__remoteAttributeDefinitions", /* @__PURE__ */ (() => /* @__PURE__ */ new Map())());
  __publicField(RemoteElement, "__remoteEventDefinitions", /* @__PURE__ */ (() => /* @__PURE__ */ new Map())());
  __publicField(RemoteElement, "__remoteSlotDefinitions", /* @__PURE__ */ (() => /* @__PURE__ */ new Map())());
  var REMOTE_EVENTS = /* @__PURE__ */ new WeakMap();
  function getRemoteEvents(element) {
    let events = REMOTE_EVENTS.get(element);
    if (events) return events;
    events = {
      events: /* @__PURE__ */ new Map(),
      properties: /* @__PURE__ */ new Map(),
      listeners: /* @__PURE__ */ new WeakMap()
    };
    REMOTE_EVENTS.set(element, events);
    return events;
  }
  function getRemoteEventRecord(type, {
    property,
    definition
  }) {
    const remoteEvents = getRemoteEvents(this);
    let remoteEvent = remoteEvents.events.get(type);
    if (remoteEvent == null) {
      remoteEvent = {
        name: type,
        property,
        definition,
        listeners: /* @__PURE__ */ new Set(),
        dispatch: (arg) => {
          const event = definition?.dispatchEvent?.call(this, arg) ?? new RemoteEvent(type, {
            detail: arg,
            bubbles: definition?.bubbles
          });
          this.dispatchEvent(event);
          return event.response;
        }
      };
      remoteEvents.events.set(type, remoteEvent);
    }
    return remoteEvent;
  }
  function removeRemoteListener(type, listener, listenerRecord) {
    const remoteEvents = getRemoteEvents(this);
    const remoteEvent = listenerRecord[1];
    remoteEvent.listeners.delete(listener);
    remoteEvents.listeners.delete(listener);
    if (remoteEvent.listeners.size > 0) return;
    remoteEvents.events.delete(type);
    if (remoteEvent.property) {
      if (remoteProperties(this)?.[remoteEvent.property] === remoteEvent.dispatch) {
        updateRemoteElementProperty(this, remoteEvent.property, void 0);
      }
    } else {
      if (remoteEventListeners(this)?.[type] === remoteEvent.dispatch) {
        updateRemoteElementEventListener(this, type, void 0);
      }
    }
  }
  function saveRemoteProperty(name, description, observedAttributes, remotePropertyDefinitions, attributeToPropertyMap, eventToPropertyMap) {
    if (remotePropertyDefinitions.has(name)) {
      return remotePropertyDefinitions.get(name);
    }
    const looksLikeEventCallback = name[0] === "o" && name[1] === "n";
    const resolvedDescription = description ?? {};
    let {
      alias
    } = resolvedDescription;
    const {
      type = looksLikeEventCallback ? Function : String,
      attribute = type !== Function,
      event = looksLikeEventCallback,
      default: defaultValue = type === Boolean ? false : void 0
    } = resolvedDescription;
    if (alias == null) {
      const lowercaseProperty = name.toLowerCase();
      if (lowercaseProperty !== name) {
        alias = [lowercaseProperty];
      }
      if (looksLikeEventCallback) {
        alias ?? (alias = []);
        alias.unshift(\`_\${name}\`);
      }
    }
    let attributeName;
    if (attribute === true) {
      attributeName = camelToKebabCase(name);
    } else if (typeof attribute === "string") {
      attributeName = attribute;
    }
    if (attributeName) {
      if (Array.isArray(observedAttributes)) {
        observedAttributes.push(attributeName);
      } else {
        observedAttributes.add(attributeName);
      }
      attributeToPropertyMap.set(attributeName, name);
    }
    let eventName;
    if (event === true) {
      eventName = camelToKebabCase(looksLikeEventCallback ? name.slice(2) : name);
    } else if (typeof event === "string") {
      eventName = event;
    }
    if (eventName) {
      eventToPropertyMap.set(eventName, name);
    }
    const definition = {
      name,
      type,
      alias,
      event: eventName,
      attribute: attributeName,
      default: defaultValue
    };
    remotePropertyDefinitions.set(name, definition);
    if (alias) {
      for (const propertyAlias of alias) {
        remotePropertyDefinitions.set(propertyAlias, definition);
      }
    }
    return definition;
  }
  function convertAttributeValueToProperty(value, type) {
    if (value == null) return void 0;
    switch (type) {
      case Boolean:
        return value != null && value !== "false";
      case Object:
      case Array:
        try {
          return JSON.parse(value);
        } catch {
          return void 0;
        }
      case String:
        return String(value);
      case Number:
        return Number.parseFloat(value);
      case Function:
        return void 0;
      default: {
        return type.parse?.(value);
      }
    }
  }
  function camelToKebabCase(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  }
  function noopBubblesEventListener() {
  }

  // ../../../node_modules/.pnpm/@remote-dom+core@1.8.1_@preact+signals-core@1.10.0/node_modules/@remote-dom/core/build/esm/elements/RemoteMutationObserver.mjs
  var RemoteMutationObserver = class extends MutationObserver {
    constructor(connection) {
      super((records) => {
        const addedNodes = [];
        const remoteRecords = [];
        for (const record of records) {
          const targetId = remoteId(record.target);
          if (record.type === "childList") {
            const position = record.previousSibling ? indexOf(record.previousSibling, record.target.childNodes) + 1 : 0;
            record.removedNodes.forEach((node) => {
              disconnectRemoteNode(node);
              remoteRecords.push([MUTATION_TYPE_REMOVE_CHILD, targetId, position]);
            });
            record.addedNodes.forEach((node, index) => {
              if (addedNodes.some((addedNode) => {
                return addedNode === node || addedNode.contains(node);
              })) {
                return;
              }
              addedNodes.push(node);
              connectRemoteNode(node, connection);
              remoteRecords.push([MUTATION_TYPE_INSERT_CHILD, targetId, serializeRemoteNode(node), position + index]);
            });
          } else if (record.type === "characterData") {
            remoteRecords.push([MUTATION_TYPE_UPDATE_TEXT, targetId, record.target.textContent ?? ""]);
          } else if (record.type === "attributes" && record.attributeName != null && record.target instanceof Element && !record.target.tagName.includes("-")) {
            remoteRecords.push([MUTATION_TYPE_UPDATE_PROPERTY, targetId, record.attributeName, record.target.getAttribute(record.attributeName)]);
          }
        }
        connection.mutate(remoteRecords);
      });
      this.connection = connection;
    }
    /**
     * Starts watching changes to the element, and communicates changes to the
     * host environment. By default, this method will also communicate any initial
     * children of the element to the host environment.
     */
    observe(target, options) {
      REMOTE_IDS.set(target, ROOT_ID);
      if (options?.initial !== false && target.childNodes.length > 0) {
        const records = [];
        for (let i = 0; i < target.childNodes.length; i++) {
          const node = target.childNodes[i];
          connectRemoteNode(node, this.connection);
          records.push([MUTATION_TYPE_INSERT_CHILD, ROOT_ID, serializeRemoteNode(node), i]);
        }
        this.connection.mutate(records);
      }
      super.observe(target, {
        subtree: true,
        childList: true,
        attributes: true,
        characterData: true,
        ...options
      });
    }
  };
  function indexOf(node, list) {
    for (let i = 0; i < list.length; i++) {
      if (list[i] === node) return i;
    }
    return -1;
  }

  // ../../../node_modules/.pnpm/@quilted+threads@3.1.3_@preact+signals-core@1.10.0/node_modules/@quilted/threads/build/esm/constants.mjs
  var MESSAGE_CALL = 1;
  var MESSAGE_CALL_RESULT = 2;
  var MESSAGE_FUNCTION_CALL = 3;
  var MESSAGE_FUNCTION_RESULT = 4;
  var MESSAGE_FUNCTION_RELEASE = 5;
  var SERIALIZE_METHOD = Symbol.for("quilt.threads.serialize");
  var TRANSFERABLE = Symbol.for("quilt.threads.transferable");

  // ../../../node_modules/.pnpm/@quilted+events@2.1.3/node_modules/@quilted/events/build/esm/abort/NestedAbortController.mjs
  var NestedAbortController = class extends AbortController {
    constructor(...parents) {
      super();
      const abortedSignal = parents.find((signal) => signal.aborted);
      if (abortedSignal) {
        this.abort(abortedSignal.reason);
      } else {
        const abort = (event) => this.abort(event.target.reason);
        const options = {
          signal: this.signal
        };
        for (const signal of parents) {
          signal.addEventListener("abort", abort, options);
        }
      }
    }
  };

  // ../../../node_modules/.pnpm/@quilted+threads@3.1.3_@preact+signals-core@1.10.0/node_modules/@quilted/threads/build/esm/errors.mjs
  var ThreadClosedError = class extends Error {
    constructor() {
      super("You attempted to call a function on a closed thread.");
    }
  };

  // ../../../node_modules/.pnpm/@quilted+threads@3.1.3_@preact+signals-core@1.10.0/node_modules/@quilted/threads/build/esm/nanoid.mjs
  var a = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  function nanoid(e = 21) {
    let t = "", r = crypto.getRandomValues(new Uint8Array(e));
    for (let n = 0; n < e; n++) t += a[63 & r[n]];
    return t;
  }

  // ../../../node_modules/.pnpm/@quilted+threads@3.1.3_@preact+signals-core@1.10.0/node_modules/@quilted/threads/build/esm/functions/ThreadFunctionsAutomatic.mjs
  var _functionsToId, _idsToFunction, _idsToProxy, _finalization, _ThreadFunctionsAutomatic_instances, finalizationRegistry_fn;
  var ThreadFunctionsAutomatic = class {
    constructor() {
      __privateAdd(this, _ThreadFunctionsAutomatic_instances);
      __privateAdd(this, _functionsToId, /* @__PURE__ */ (() => /* @__PURE__ */ new Map())());
      __privateAdd(this, _idsToFunction, /* @__PURE__ */ (() => /* @__PURE__ */ new Map())());
      __privateAdd(this, _idsToProxy, /* @__PURE__ */ (() => /* @__PURE__ */ new Map())());
      __privateAdd(this, _finalization, /* @__PURE__ */ (() => /* @__PURE__ */ new WeakMap())());
    }
    get(id2) {
      return __privateGet(this, _idsToFunction).get(id2);
    }
    release(id2) {
      const func = __privateGet(this, _idsToFunction).get(id2);
      if (func) {
        __privateGet(this, _idsToFunction).delete(id2);
        __privateGet(this, _functionsToId).delete(func);
      }
      return Boolean(func);
    }
    serialize(func) {
      let id2 = __privateGet(this, _functionsToId).get(func);
      if (id2 == null) {
        id2 = nanoid();
        __privateGet(this, _functionsToId).set(func, id2);
        __privateGet(this, _idsToFunction).set(id2, func);
      }
      return id2;
    }
    deserialize(id2, thread) {
      let proxy = __privateGet(this, _idsToProxy).get(id2)?.deref();
      if (proxy) return proxy;
      proxy = (...args) => {
        if (!__privateGet(this, _idsToProxy).has(id2)) {
          throw new Error("You attempted to call a function that was already revoked.");
        }
        return thread.call((callID, args2, transferable) => {
          thread.messages.send([MESSAGE_FUNCTION_CALL, callID, id2, args2], transferable);
        }, args);
      };
      __privateMethod(this, _ThreadFunctionsAutomatic_instances, finalizationRegistry_fn).call(this, thread)?.register(proxy, id2);
      __privateGet(this, _idsToProxy).set(id2, new WeakRef(proxy));
      return proxy;
    }
  };
  _functionsToId = new WeakMap();
  _idsToFunction = new WeakMap();
  _idsToProxy = new WeakMap();
  _finalization = new WeakMap();
  _ThreadFunctionsAutomatic_instances = new WeakSet();
  finalizationRegistry_fn = function(thread) {
    let finalization = __privateGet(this, _finalization).get(thread);
    if (typeof FinalizationRegistry === "undefined") {
      return void 0;
    }
    if (!finalization) {
      finalization = new FinalizationRegistry((id2) => {
        thread.messages.send([MESSAGE_FUNCTION_RELEASE, id2]);
      });
      __privateGet(this, _finalization).set(thread, finalization);
    }
    return finalization;
  };

  // ../../../node_modules/.pnpm/@quilted+threads@3.1.3_@preact+signals-core@1.10.0/node_modules/@quilted/threads/build/esm/serialization/shared.mjs
  function isIterator(value) {
    return value != null && (Symbol.asyncIterator in value || Symbol.iterator in value) && typeof value.next === "function";
  }
  function isBasicObject(value) {
    if (value == null || typeof value !== "object") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype == null || prototype === Object.prototype;
  }

  // ../../../node_modules/.pnpm/@quilted+threads@3.1.3_@preact+signals-core@1.10.0/node_modules/@quilted/threads/build/esm/serialization/ThreadSerializationStructuredClone.mjs
  var FUNCTION = "_@f";
  var ASYNC_ITERATOR = "_@i";
  var _customSerializer, _customDeserializer, _ThreadSerializationStructuredClone_instances, serializeInternal_fn, deserializeInternal_fn;
  var ThreadSerializationStructuredClone = class {
    constructor(options) {
      __privateAdd(this, _ThreadSerializationStructuredClone_instances);
      __privateAdd(this, _customSerializer);
      __privateAdd(this, _customDeserializer);
      __privateSet(this, _customSerializer, options?.serialize);
      __privateSet(this, _customDeserializer, options?.deserialize);
    }
    /**
     * Serializes a value into a structured cloning-compatible format that can be transferred between threads.
     */
    serialize(value, thread, transferable) {
      return __privateMethod(this, _ThreadSerializationStructuredClone_instances, serializeInternal_fn).call(this, value, thread, transferable);
    }
    /**
     * Deserializes a structured cloning-compatible value from another thread.
     */
    deserialize(value, thread) {
      return __privateMethod(this, _ThreadSerializationStructuredClone_instances, deserializeInternal_fn).call(this, value, thread);
    }
  };
  _customSerializer = new WeakMap();
  _customDeserializer = new WeakMap();
  _ThreadSerializationStructuredClone_instances = new WeakSet();
  serializeInternal_fn = function(value, thread, transferable, seen = /* @__PURE__ */ new Map(), isApplyingDefault = false) {
    if (value == null) return value;
    if (seen.has(value)) return seen.get(value);
    seen.set(value, void 0);
    if (typeof value === "object") {
      if (__privateGet(this, _customSerializer) && !isApplyingDefault) {
        const customValue = __privateGet(this, _customSerializer).call(this, value, (value2) => __privateMethod(this, _ThreadSerializationStructuredClone_instances, serializeInternal_fn).call(this, value2, thread, transferable, seen, true), thread, transferable);
        if (customValue !== void 0) {
          seen.set(value, customValue);
          return customValue;
        }
      }
      if (value[TRANSFERABLE]) {
        transferable?.push(value);
        seen.set(value, value);
        return value;
      }
      const serializeValue = (value2) => {
        return __privateMethod(this, _ThreadSerializationStructuredClone_instances, serializeInternal_fn).call(this, value2, thread, transferable, seen);
      };
      if (typeof value[SERIALIZE_METHOD] === "function") {
        const result = value[SERIALIZE_METHOD]({
          serialize: serializeValue
        });
        seen.set(value, result);
        return result;
      }
      if (Array.isArray(value)) {
        const result = value.map((item) => serializeValue(item));
        seen.set(value, result);
        return result;
      }
      if (value instanceof Map) {
        const entries = [...value.entries()].map(([key, value2]) => {
          return [serializeValue(key), serializeValue(value2)];
        });
        const result = new Map(entries);
        seen.set(value, result);
        return result;
      }
      if (value instanceof Set) {
        const entries = [...value].map((entry) => serializeValue(entry));
        const result = new Set(entries);
        seen.set(value, result);
        return result;
      }
      const valueIsIterator = isIterator(value);
      if (isBasicObject(value) || valueIsIterator) {
        const result = {};
        for (const key of Object.keys(value)) {
          result[key] = serializeValue(value[key]);
        }
        if (valueIsIterator) {
          result.next ?? (result.next = serializeValue(value.next.bind(value)));
          result.return ?? (result.return = serializeValue(value.return.bind(value)));
          result.throw ?? (result.throw = serializeValue(value.throw.bind(value)));
          result[ASYNC_ITERATOR] = true;
        }
        seen.set(value, result);
        return result;
      }
    }
    if (typeof value === "function") {
      const serialized = thread.functions.serialize(value, thread, transferable);
      const result = {
        [FUNCTION]: serialized
      };
      seen.set(value, result);
      return result;
    }
    seen.set(value, value);
    return value;
  };
  deserializeInternal_fn = function(value, thread, isApplyingDefault = false) {
    if (value == null) return value;
    if (typeof value === "object") {
      if (__privateGet(this, _customDeserializer) && !isApplyingDefault) {
        const customValue = __privateGet(this, _customDeserializer).call(this, value, (value2) => __privateMethod(this, _ThreadSerializationStructuredClone_instances, deserializeInternal_fn).call(this, value2, thread, true), thread);
        if (customValue !== void 0) {
          return customValue;
        }
      }
      if (value == null) {
        return value;
      }
      if (Array.isArray(value)) {
        return value.map((value2) => __privateMethod(this, _ThreadSerializationStructuredClone_instances, deserializeInternal_fn).call(this, value2, thread));
      }
      if (value instanceof Map) {
        return new Map([...value].map(([key, value2]) => [__privateMethod(this, _ThreadSerializationStructuredClone_instances, deserializeInternal_fn).call(this, key, thread), __privateMethod(this, _ThreadSerializationStructuredClone_instances, deserializeInternal_fn).call(this, value2, thread)]));
      }
      if (value instanceof Set) {
        return new Set([...value].map((entry) => __privateMethod(this, _ThreadSerializationStructuredClone_instances, deserializeInternal_fn).call(this, entry, thread)));
      }
      if (FUNCTION in value) {
        const func = thread.functions.deserialize(value[FUNCTION], thread);
        return func;
      }
      if (!isBasicObject(value)) {
        return value;
      }
      const result = {};
      for (const key of Object.keys(value)) {
        if (key === ASYNC_ITERATOR) {
          result[Symbol.asyncIterator] = () => result;
        } else {
          result[key] = __privateMethod(this, _ThreadSerializationStructuredClone_instances, deserializeInternal_fn).call(this, value[key], thread);
        }
      }
      return result;
    }
    return value;
  };

  // ../../../node_modules/.pnpm/@quilted+threads@3.1.3_@preact+signals-core@1.10.0/node_modules/@quilted/threads/build/esm/Thread.mjs
  var _abort, _idsToResolver, _Thread_instances, callLocal_fn, handlerForCall_fn, resolveCall_fn, waitForResult_fn;
  var Thread = class {
    constructor(messages, {
      imports,
      exports,
      functions = new ThreadFunctionsAutomatic(),
      serialization = new ThreadSerializationStructuredClone(),
      signal
    } = {}) {
      __privateAdd(this, _Thread_instances);
      __privateAdd(this, _abort);
      __privateAdd(this, _idsToResolver, /* @__PURE__ */ (() => /* @__PURE__ */ new Map())());
      this.messages = messages;
      __privateSet(this, _abort, signal ? new NestedAbortController(signal) : new AbortController());
      this.exports = exports ?? {};
      this.imports = createThreadImports(__privateMethod(this, _Thread_instances, handlerForCall_fn).bind(this), imports);
      this.functions = functions;
      this.serialization = serialization;
      this.functions.start?.(this);
      this.serialization.start?.(this);
      this.signal.addEventListener("abort", () => {
        for (const id2 of __privateGet(this, _idsToResolver).keys()) {
          __privateMethod(this, _Thread_instances, resolveCall_fn).call(this, id2, void 0, new ThreadClosedError());
        }
        __privateGet(this, _idsToResolver).clear();
      }, {
        once: true
      });
      messages.listen(async (rawData) => {
        const isThreadMessageData = Array.isArray(rawData) && typeof rawData[0] === "number";
        if (!isThreadMessageData) {
          return;
        }
        const data = rawData;
        switch (data[0]) {
          case MESSAGE_CALL: {
            const [, id2, property, args] = data;
            const func = this.exports[property] ?? (() => {
              throw new Error(\`No '\${property}' method is exported from this thread\`);
            });
            await __privateMethod(this, _Thread_instances, callLocal_fn).call(this, func, args, (value, error, transferable) => {
              this.messages.send([MESSAGE_CALL_RESULT, id2, value, error], transferable);
            });
            break;
          }
          case MESSAGE_FUNCTION_CALL: {
            const [, callID, funcID, args] = data;
            const func = this.functions.get(funcID, this) ?? missingThreadFunction;
            await __privateMethod(this, _Thread_instances, callLocal_fn).call(this, func, args, (value, error, transferable) => {
              this.messages.send([MESSAGE_FUNCTION_RESULT, callID, value, error], transferable);
            });
            break;
          }
          case MESSAGE_CALL_RESULT:
          case MESSAGE_FUNCTION_RESULT: {
            __privateMethod(this, _Thread_instances, resolveCall_fn).call(this, ...data.slice(1));
            break;
          }
          case MESSAGE_FUNCTION_RELEASE: {
            const id2 = data[1];
            this.functions.release(id2, this);
            break;
          }
        }
      }, {
        signal: this.signal
      });
    }
    /**
     * An object that exposes the methods that can be called on the paired thread.
     * This object will automatically encode and decode arguments and return values
     * as necessary.
     */
    /**
     * An object that exposes the methods that can be called on this thread by the
     * paired thread. To set these methods, pass the \`exports\` option when creating
     * a new \`Thread\`.
     */
    /**
     * An object that provides the message-passing interface that allows communication
     * to flow between environments.
     */
    /**
     * An object that manages how functions are proxied between threads.
     */
    /**
     * An object that manages how values are serialized and deserialized between threads.
     */
    /**
     * An \`AbortSignal\` that indicates whether the communication channel is still open.
     */
    get signal() {
      return __privateGet(this, _abort).signal;
    }
    /**
     * A boolean indicating whether the communication channel is still open.
     */
    get closed() {
      return __privateGet(this, _abort).signal.aborted;
    }
    /**
     * Closes the communication channel between the two threads. This will prevent
     * any further communication between the threads, and will clean up any memory
     * associated with in-progress communication. It will also reject any inflight
     * function calls between threads with a \`ThreadClosedError\`.
     */
    close() {
      __privateGet(this, _abort).abort();
    }
    /**
     * Requests that the thread provide the context needed to make a function
     * call between threads. You provide this method a function to call and the
     * unserialized arguments you wish to call it with, and the thread will call
     * the function you provided with a serialized call ID, the serialized arguments,
     * and any transferable objects that need to be passed between threads.
     */
    call(func, args) {
      if (this.closed) {
        return Promise.reject(new ThreadClosedError());
      }
      const transferable = [];
      const serialized = this.serialization.serialize(args, this, transferable);
      const id2 = nanoid();
      const done = __privateMethod(this, _Thread_instances, waitForResult_fn).call(this, id2);
      func(id2, serialized, transferable);
      return done;
    }
  };
  _abort = new WeakMap();
  _idsToResolver = new WeakMap();
  _Thread_instances = new WeakSet();
  callLocal_fn = async function(func, args, withResult) {
    try {
      const result = this.functions.call ? await this.functions.call(func, args, this) : await func(...this.serialization.deserialize(args, this));
      const transferable = [];
      const serialized = this.serialization.serialize(result, this, transferable);
      withResult(serialized, void 0, transferable);
    } catch (error) {
      withResult(void 0, this.serialization.serialize(error, this));
    }
  };
  handlerForCall_fn = function(property) {
    return (...args) => {
      try {
        if (typeof property !== "string" && typeof property !== "number") {
          throw new Error(\`Can’t call a symbol method on a thread: \${property.toString()}\`);
        }
        return this.call((id2, serializedArgs, transferable) => {
          this.messages.send([MESSAGE_CALL, id2, property, serializedArgs], transferable);
        }, args);
      } catch (error) {
        return Promise.reject(error);
      }
    };
  };
  resolveCall_fn = function(...args) {
    const callID = args[0];
    const resolver = __privateGet(this, _idsToResolver).get(callID);
    if (resolver) {
      resolver(...args);
      __privateGet(this, _idsToResolver).delete(callID);
    }
  };
  waitForResult_fn = function(id2) {
    const promise = new Promise((resolve, reject) => {
      __privateGet(this, _idsToResolver).set(id2, (_, value, error) => {
        if (error == null) {
          resolve(this.serialization.deserialize(value, this));
        } else {
          reject(this.serialization.deserialize(error, this));
        }
      });
    });
    Object.defineProperty(promise, Symbol.asyncIterator, {
      async *value() {
        const result = await promise;
        Object.defineProperty(result, Symbol.asyncIterator, {
          value: () => result
        });
        yield* result;
      }
    });
    return promise;
  };
  function createThreadImports(handlerForImport, imported) {
    let call;
    if (imported == null) {
      if (typeof Proxy !== "function") {
        throw new Error(\`You must pass an array of callable methods in environments without Proxies.\`);
      }
      const cache = /* @__PURE__ */ new Map();
      call = new Proxy({}, {
        get(_target, property) {
          if (cache.has(property)) {
            return cache.get(property);
          }
          const handler = handlerForImport(property);
          cache.set(property, handler);
          return handler;
        }
      });
    } else {
      call = {};
      for (const method of imported) {
        Object.defineProperty(call, method, {
          value: handlerForImport(method),
          writable: false,
          configurable: true,
          enumerable: true
        });
      }
    }
    return call;
  }
  function missingThreadFunction() {
    throw new Error(\`You attempted to call a function that is not stored. It may have already been released.\`);
  }

  // ../../../node_modules/.pnpm/@quilted+threads@3.1.3_@preact+signals-core@1.10.0/node_modules/@quilted/threads/build/esm/threads/window/shared.mjs
  var CHECK_MESSAGE = "quilt.threads.ping";
  var RESPONSE_MESSAGE = "quilt.threads.pong";

  // ../../../node_modules/.pnpm/@quilted+threads@3.1.3_@preact+signals-core@1.10.0/node_modules/@quilted/threads/build/esm/threads/window/ThreadNestedWindow.mjs
  function nestedWindowToThreadTarget(parent, {
    targetOrigin = "*"
  } = {}) {
    const ready = () => {
      const respond = () => parent.postMessage(RESPONSE_MESSAGE, targetOrigin);
      self.addEventListener("message", ({
        data,
        source
      }) => {
        if (source !== parent) return;
        if (data === CHECK_MESSAGE) respond();
      });
      respond();
    };
    if (document.readyState === "complete") {
      ready();
    } else {
      document.addEventListener("readystatechange", () => {
        if (document.readyState === "complete") {
          ready();
        }
      });
    }
    return {
      send(message, transfer) {
        return parent.postMessage(message, targetOrigin, transfer);
      },
      listen(listen, {
        signal
      }) {
        self.addEventListener("message", (event) => {
          if (event.data === CHECK_MESSAGE) return;
          listen(event.data);
        }, {
          signal
        });
      }
    };
  }

  // ../../../node_modules/.pnpm/@quilted+threads@3.1.3_@preact+signals-core@1.10.0/node_modules/@quilted/threads/build/esm/threads/ThreadNestedIframe.mjs
  var ThreadNestedIframe = class extends Thread {
    constructor({
      parent = globalThis.parent,
      targetOrigin = "*",
      ...options
    } = {}) {
      if (typeof self === "undefined" || parent == null) {
        throw new Error("You are not inside an iframe, because there is no parent window.");
      }
      super(nestedWindowToThreadTarget(parent, {
        targetOrigin
      }), options);
      this.parent = parent;
    }
  };

  // scripts/iframe-entry.js
  new ThreadNestedIframe({
    exports: {
      async render(options, receiver, hostApi) {
        if (options.remoteElements) {
          options.remoteElements.forEach((def) => {
            if (customElements.get(def.tagName)) return;
            const remoteElement = class extends RemoteElement {
              static get remoteAttributes() {
                return def.remoteAttributes || [];
              }
              static get remoteEvents() {
                return def.remoteEvents || [];
              }
            };
            Object.defineProperty(remoteElement, "name", {
              value: \`Remote\${def.tagName.replace(
                /(^w|-w)/g,
                (c) => c.replace("-", "").toUpperCase()
              )}\`
            });
            customElements.define(def.tagName, remoteElement);
          });
        }
        const root = document.querySelector("#root");
        const observer = new RemoteMutationObserver(receiver);
        observer.observe(root);
        const { code } = options;
        if (code && root) {
          try {
            const scriptFunction = new Function("root", "console", code);
            scriptFunction(root, console);
          } catch (e) {
            console.error("Error executing remote script:", e);
          }
        }
      }
    }
  });
})();

  <\/script>
</body>
</html>`, ve = 1, ye = 2, Le = 3, Te = 4, Ue = 5, ge = Symbol.for("quilt.threads.serialize"), yt = Symbol.for("quilt.threads.transferable");
class Tt extends AbortController {
  constructor(...e) {
    super();
    const t = e.find((n) => n.aborted);
    if (t)
      this.abort(t.reason);
    else {
      const n = (o) => this.abort(o.target.reason), s = {
        signal: this.signal
      };
      for (const o of e)
        o.addEventListener("abort", n, s);
    }
  }
}
class Re extends Error {
  constructor() {
    super("You attempted to call a function on a closed thread.");
  }
}
let gt = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
function ze(r = 21) {
  let e = "", t = crypto.getRandomValues(new Uint8Array(r));
  for (let n = 0; n < r; n++) e += gt[63 & t[n]];
  return e;
}
var Y, x, G, K, ee, xe;
class Rt {
  constructor() {
    S(this, ee);
    S(this, Y, /* @__PURE__ */ new Map());
    S(this, x, /* @__PURE__ */ new Map());
    S(this, G, /* @__PURE__ */ new Map());
    S(this, K, /* @__PURE__ */ new WeakMap());
  }
  get(e) {
    return b(this, x).get(e);
  }
  release(e) {
    const t = b(this, x).get(e);
    return t && (b(this, x).delete(e), b(this, Y).delete(t)), !!t;
  }
  serialize(e) {
    let t = b(this, Y).get(e);
    return t == null && (t = ze(), b(this, Y).set(e, t), b(this, x).set(t, e)), t;
  }
  deserialize(e, t) {
    var s, o;
    let n = (s = b(this, G).get(e)) == null ? void 0 : s.deref();
    return n || (n = (...a) => {
      if (!b(this, G).has(e))
        throw new Error("You attempted to call a function that was already revoked.");
      return t.call((u, l, f) => {
        t.messages.send([Le, u, e, l], f);
      }, a);
    }, (o = y(this, ee, xe).call(this, t)) == null || o.register(n, e), b(this, G).set(e, new WeakRef(n)), n);
  }
}
Y = new WeakMap(), x = new WeakMap(), G = new WeakMap(), K = new WeakMap(), ee = new WeakSet(), xe = function(e) {
  let t = b(this, K).get(e);
  if (!(typeof FinalizationRegistry > "u"))
    return t || (t = new FinalizationRegistry((n) => {
      e.messages.send([Ue, n]);
    }), b(this, K).set(e, t)), t;
};
function wt(r) {
  return r != null && (Symbol.asyncIterator in r || Symbol.iterator in r) && typeof r.next == "function";
}
function we(r) {
  if (r == null || typeof r != "object") return !1;
  const e = Object.getPrototypeOf(r);
  return e == null || e === Object.prototype;
}
const ie = "_@f", Se = "_@i";
var V, W, w, Q, O;
class St {
  constructor(e) {
    S(this, w);
    S(this, V);
    S(this, W);
    Z(this, V, e == null ? void 0 : e.serialize), Z(this, W, e == null ? void 0 : e.deserialize);
  }
  /**
   * Serializes a value into a structured cloning-compatible format that can be transferred between threads.
   */
  serialize(e, t, n) {
    return y(this, w, Q).call(this, e, t, n);
  }
  /**
   * Deserializes a structured cloning-compatible value from another thread.
   */
  deserialize(e, t) {
    return y(this, w, O).call(this, e, t);
  }
}
V = new WeakMap(), W = new WeakMap(), w = new WeakSet(), Q = function(e, t, n, s = /* @__PURE__ */ new Map(), o = !1) {
  if (e == null) return e;
  if (s.has(e)) return s.get(e);
  if (s.set(e, void 0), typeof e == "object") {
    if (b(this, V) && !o) {
      const l = b(this, V).call(this, e, (f) => y(this, w, Q).call(this, f, t, n, s, !0), t, n);
      if (l !== void 0)
        return s.set(e, l), l;
    }
    if (e[yt])
      return n == null || n.push(e), s.set(e, e), e;
    const a = (l) => y(this, w, Q).call(this, l, t, n, s);
    if (typeof e[ge] == "function") {
      const l = e[ge]({
        serialize: a
      });
      return s.set(e, l), l;
    }
    if (Array.isArray(e)) {
      const l = e.map((f) => a(f));
      return s.set(e, l), l;
    }
    if (e instanceof Map) {
      const l = [...e.entries()].map(([i, m]) => [a(i), a(m)]), f = new Map(l);
      return s.set(e, f), f;
    }
    if (e instanceof Set) {
      const l = [...e].map((i) => a(i)), f = new Set(l);
      return s.set(e, f), f;
    }
    const u = wt(e);
    if (we(e) || u) {
      const l = {};
      for (const f of Object.keys(e))
        l[f] = a(e[f]);
      return u && (l.next ?? (l.next = a(e.next.bind(e))), l.return ?? (l.return = a(e.return.bind(e))), l.throw ?? (l.throw = a(e.throw.bind(e))), l[Se] = !0), s.set(e, l), l;
    }
  }
  if (typeof e == "function") {
    const a = t.functions.serialize(e, t, n), u = {
      [ie]: a
    };
    return s.set(e, u), u;
  }
  return s.set(e, e), e;
}, O = function(e, t, n = !1) {
  if (e == null) return e;
  if (typeof e == "object") {
    if (b(this, W) && !n) {
      const o = b(this, W).call(this, e, (a) => y(this, w, O).call(this, a, t, !0), t);
      if (o !== void 0)
        return o;
    }
    if (e == null)
      return e;
    if (Array.isArray(e))
      return e.map((o) => y(this, w, O).call(this, o, t));
    if (e instanceof Map)
      return new Map([...e].map(([o, a]) => [y(this, w, O).call(this, o, t), y(this, w, O).call(this, a, t)]));
    if (e instanceof Set)
      return new Set([...e].map((o) => y(this, w, O).call(this, o, t)));
    if (ie in e)
      return t.functions.deserialize(e[ie], t);
    if (!we(e))
      return e;
    const s = {};
    for (const o of Object.keys(e))
      o === Se ? s[Symbol.asyncIterator] = () => s : s[o] = y(this, w, O).call(this, e[o], t);
    return s;
  }
  return e;
};
var k, D, M, ae, ke, le, je;
class Mt {
  constructor(e, {
    imports: t,
    exports: n,
    functions: s = new Rt(),
    serialization: o = new St(),
    signal: a
  } = {}) {
    S(this, M);
    S(this, k);
    S(this, D, /* @__PURE__ */ new Map());
    var u, l, f, i;
    this.messages = e, Z(this, k, a ? new Tt(a) : new AbortController()), this.exports = n ?? {}, this.imports = At(y(this, M, ke).bind(this), t), this.functions = s, this.serialization = o, (l = (u = this.functions).start) == null || l.call(u, this), (i = (f = this.serialization).start) == null || i.call(f, this), this.signal.addEventListener("abort", () => {
      for (const m of b(this, D).keys())
        y(this, M, le).call(this, m, void 0, new Re());
      b(this, D).clear();
    }, {
      once: !0
    }), e.listen(async (m) => {
      if (!(Array.isArray(m) && typeof m[0] == "number"))
        return;
      const c = m;
      switch (c[0]) {
        case ve: {
          const [, p, h, E] = c, _ = this.exports[h] ?? (() => {
            throw new Error(`No '${h}' method is exported from this thread`);
          });
          await y(this, M, ae).call(this, _, E, (R, N, T) => {
            this.messages.send([ye, p, R, N], T);
          });
          break;
        }
        case Le: {
          const [, p, h, E] = c, _ = this.functions.get(h, this) ?? Nt;
          await y(this, M, ae).call(this, _, E, (R, N, T) => {
            this.messages.send([Te, p, R, N], T);
          });
          break;
        }
        case ye:
        case Te: {
          y(this, M, le).call(this, ...c.slice(1));
          break;
        }
        case Ue: {
          const p = c[1];
          this.functions.release(p, this);
          break;
        }
      }
    }, {
      signal: this.signal
    });
  }
  /**
   * An object that exposes the methods that can be called on the paired thread.
   * This object will automatically encode and decode arguments and return values
   * as necessary.
   */
  /**
   * An object that exposes the methods that can be called on this thread by the
   * paired thread. To set these methods, pass the `exports` option when creating
   * a new `Thread`.
   */
  /**
   * An object that provides the message-passing interface that allows communication
   * to flow between environments.
   */
  /**
   * An object that manages how functions are proxied between threads.
   */
  /**
   * An object that manages how values are serialized and deserialized between threads.
   */
  /**
   * An `AbortSignal` that indicates whether the communication channel is still open.
   */
  get signal() {
    return b(this, k).signal;
  }
  /**
   * A boolean indicating whether the communication channel is still open.
   */
  get closed() {
    return b(this, k).signal.aborted;
  }
  /**
   * Closes the communication channel between the two threads. This will prevent
   * any further communication between the threads, and will clean up any memory
   * associated with in-progress communication. It will also reject any inflight
   * function calls between threads with a `ThreadClosedError`.
   */
  close() {
    b(this, k).abort();
  }
  /**
   * Requests that the thread provide the context needed to make a function
   * call between threads. You provide this method a function to call and the
   * unserialized arguments you wish to call it with, and the thread will call
   * the function you provided with a serialized call ID, the serialized arguments,
   * and any transferable objects that need to be passed between threads.
   */
  call(e, t) {
    if (this.closed)
      return Promise.reject(new Re());
    const n = [], s = this.serialization.serialize(t, this, n), o = ze(), a = y(this, M, je).call(this, o);
    return e(o, s, n), a;
  }
}
k = new WeakMap(), D = new WeakMap(), M = new WeakSet(), ae = async function(e, t, n) {
  try {
    const s = this.functions.call ? await this.functions.call(e, t, this) : await e(...this.serialization.deserialize(t, this)), o = [], a = this.serialization.serialize(s, this, o);
    n(a, void 0, o);
  } catch (s) {
    n(void 0, this.serialization.serialize(s, this));
  }
}, ke = function(e) {
  return (...t) => {
    try {
      if (typeof e != "string" && typeof e != "number")
        throw new Error(`Can’t call a symbol method on a thread: ${e.toString()}`);
      return this.call((n, s, o) => {
        this.messages.send([ve, n, e, s], o);
      }, t);
    } catch (n) {
      return Promise.reject(n);
    }
  };
}, le = function(...e) {
  const t = e[0], n = b(this, D).get(t);
  n && (n(...e), b(this, D).delete(t));
}, je = function(e) {
  const t = new Promise((n, s) => {
    b(this, D).set(e, (o, a, u) => {
      u == null ? n(this.serialization.deserialize(a, this)) : s(this.serialization.deserialize(u, this));
    });
  });
  return Object.defineProperty(t, Symbol.asyncIterator, {
    async *value() {
      const n = await t;
      Object.defineProperty(n, Symbol.asyncIterator, {
        value: () => n
      }), yield* n;
    }
  }), t;
};
function At(r, e) {
  let t;
  if (e == null) {
    if (typeof Proxy != "function")
      throw new Error("You must pass an array of callable methods in environments without Proxies.");
    const n = /* @__PURE__ */ new Map();
    t = new Proxy({}, {
      get(s, o) {
        if (n.has(o))
          return n.get(o);
        const a = r(o);
        return n.set(o, a), a;
      }
    });
  } else {
    t = {};
    for (const n of e)
      Object.defineProperty(t, n, {
        value: r(n),
        writable: !1,
        configurable: !0,
        enumerable: !0
      });
  }
  return t;
}
function Nt() {
  throw new Error("You attempted to call a function that is not stored. It may have already been released.");
}
const It = "quilt.threads.ping", Me = "quilt.threads.pong";
function Pt(r, {
  targetOrigin: e = "*"
} = {}) {
  let t = !1;
  const n = function(a, u) {
    r.postMessage(a, e, u);
  }, s = new Promise((o) => {
    const a = new AbortController();
    globalThis.window.addEventListener("message", (u) => {
      u.source === r && u.data === Me && (t = !0, a.abort(), o());
    }, {
      signal: a.signal
    }), a.signal.addEventListener("abort", () => o(), {
      once: !0
    }), n(It);
  });
  return {
    send(o, a) {
      return t ? n(o, a) : s.then(() => {
        if (t) return n(o, a);
      });
    },
    listen(o, {
      signal: a
    }) {
      self.addEventListener("message", (u) => {
        u.source === r && u.data !== Me && o(u.data);
      }, {
        signal: a
      });
    }
  };
}
class Ot extends Mt {
  constructor(e, {
    targetOrigin: t = "*",
    ...n
  } = {}) {
    super(Pt(e.contentWindow, {
      targetOrigin: t
    }), n), this.iframe = e;
  }
}
const Fe = re.forwardRef(({ content: r, children: e, ...t }, n) => /* @__PURE__ */ v("span", { ref: n, ...t, children: r || e }));
Fe.displayName = "UIText";
const Ye = re.forwardRef(({ label: r, onPress: e, onClick: t, children: n, ...s }, o) => /* @__PURE__ */ v(
  "button",
  {
    ref: o,
    onClick: (u) => {
      e && e(), t && t(u);
    },
    style: {
      padding: "8px 16px",
      backgroundColor: "#007bff",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer"
    },
    ...s,
    children: r || n
  }
));
Ye.displayName = "UIButton";
const Ge = re.forwardRef(
  ({
    direction: r = "vertical",
    spacing: e = "8",
    align: t = "stretch",
    justify: n = "flex-start",
    children: s,
    ...o
  }, a) => /* @__PURE__ */ v(
    "div",
    {
      ref: a,
      style: {
        display: "flex",
        flexDirection: r === "horizontal" ? "row" : "column",
        gap: `${e}px`,
        alignItems: t,
        justifyContent: n
      },
      ...o,
      children: s
    }
  )
);
Ge.displayName = "UIStack";
const Ve = re.forwardRef(({ src: r, alt: e, width: t, height: n, children: s, ...o }, a) => /* @__PURE__ */ v(
  "img",
  {
    ref: a,
    src: r,
    alt: e,
    width: t,
    height: n,
    style: {
      maxWidth: "100%",
      height: "auto",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
    },
    ...o
  }
));
Ve.displayName = "UIImage";
const We = {
  name: "basic",
  elements: [
    {
      tagName: "ui-text",
      component: Fe,
      propMapping: {
        content: "content"
      },
      eventMapping: {}
    },
    {
      tagName: "ui-button",
      component: Ye,
      propMapping: {
        label: "label"
      },
      eventMapping: {
        press: "onPress"
      }
    },
    {
      tagName: "ui-stack",
      component: Ge,
      propMapping: {
        direction: "direction",
        spacing: "spacing",
        align: "align",
        justify: "justify"
      },
      eventMapping: {}
    },
    {
      tagName: "ui-image",
      component: Ve,
      propMapping: {
        src: "src",
        alt: "alt",
        width: "width",
        height: "height"
      },
      eventMapping: {}
    }
  ]
}, Dt = ({ receiver: r }) => {
  const e = B(null);
  return H(() => {
    if (e.current)
      return r.connect(e.current), () => {
        r.disconnect();
      };
  }, [r]), /* @__PURE__ */ v("div", { ref: e, "data-testid": "standard-dom-renderer-container" });
}, Ct = ({
  resource: r,
  library: e,
  remoteElements: t = [],
  onUIAction: n
}) => {
  const s = B(null), o = B(null), [a, u] = Ae(null), l = z(() => (r.mimeType || "").includes("framework=react") ? "react" : "webcomponents", [r.mimeType]), f = `${e == null ? void 0 : e.name}-${l}`, { receiver: i, components: m } = z(() => {
    switch (l) {
      case "react": {
        const c = new dt(), p = e || We, h = /* @__PURE__ */ new Map();
        return p && p.elements.forEach((E) => {
          const _ = _t(E.component);
          h.set(E.tagName, _);
        }), {
          receiver: c,
          components: h
        };
      }
      case "webcomponents":
      default:
        return {
          receiver: new ut(),
          components: null
        };
    }
  }, [r, e, t]);
  H(() => {
    function c(p) {
      var h;
      if (s.current && p.source === s.current.contentWindow) {
        const E = p.data;
        if (!E)
          return;
        (h = n == null ? void 0 : n(E)) == null || h.catch((_) => {
          console.error("Error handling UI action result in RemoteDOMResourceRenderer:", _);
        });
      }
    }
    return window.addEventListener("message", c), () => window.removeEventListener("message", c);
  }, [n]), H(() => {
    const c = o.current;
    return o.current = null, () => {
      c == null || c.close();
    };
  }, [f]);
  const d = () => {
    const c = s.current;
    if (!c || o.current)
      return;
    const p = new Ot(c);
    o.current = p;
    const { code: h, error: E } = tt(r);
    if (E) {
      u(E);
      return;
    }
    if (h && (i != null && i.connection)) {
      const _ = {
        code: h,
        remoteElements: t,
        useReactRenderer: l === "react",
        componentLibrary: e == null ? void 0 : e.name
      };
      p.imports.render(_, i.connection).catch((R) => console.error("Error calling remote render:", R));
    }
  };
  return a ? /* @__PURE__ */ v("p", { className: "text-red-500", children: a }) : /* @__PURE__ */ ce(te, { children: [
    /* @__PURE__ */ v(
      "iframe",
      {
        ref: s,
        srcDoc: vt,
        sandbox: "allow-scripts",
        style: { display: "none" },
        title: "Remote DOM Sandbox",
        onLoad: d
      },
      f
    ),
    l === "react" && m ? /* @__PURE__ */ v(bt, { receiver: i, components: m }) : /* @__PURE__ */ v(Dt, { receiver: i })
  ] });
};
function Lt(r) {
  var e;
  if (r.contentType)
    return r.contentType;
  if (r.mimeType === "text/html")
    return "rawHtml";
  if (r.mimeType === "text/uri-list")
    return "externalUrl";
  if ((e = r.mimeType) != null && e.startsWith("application/vnd.mcp-ui.remote-dom"))
    return "remoteDom";
}
const Ut = (r) => {
  const { resource: e, onUIAction: t, supportedContentTypes: n, htmlProps: s, remoteDomProps: o } = r, a = Lt(e);
  if (n && a && !n.includes(a))
    return /* @__PURE__ */ ce("p", { className: "text-red-500", children: [
      "Unsupported content type: ",
      a,
      "."
    ] });
  switch (a) {
    case "rawHtml":
    case "externalUrl":
      return /* @__PURE__ */ v(Ne, { resource: e, onUIAction: t, ...s });
    case "remoteDom":
      return /* @__PURE__ */ v(
        Ct,
        {
          resource: e,
          onUIAction: t,
          library: (o == null ? void 0 : o.library) || We,
          ...o
        }
      );
    default:
      return /* @__PURE__ */ v("p", { className: "text-red-500", children: "Unsupported resource type." });
  }
};
Ut.displayName = "UIResourceRenderer";
function jt(r) {
  var e, t;
  return (r.type === "resource" && ((t = (e = r.resource) == null ? void 0 : e.uri) == null ? void 0 : t.startsWith("ui://"))) ?? !1;
}
const Ft = {
  tagName: "ui-card"
}, Yt = {
  tagName: "ui-button",
  remoteAttributes: ["label"],
  remoteEvents: ["click", "press"]
}, Gt = {
  tagName: "ui-text",
  remoteAttributes: ["content"]
}, Vt = {
  tagName: "ui-stack",
  remoteAttributes: ["direction", "spacing", "align", "justify"]
}, Wt = {
  tagName: "ui-image",
  remoteAttributes: ["src", "alt", "width", "height"]
};
export {
  Ut as UIResourceRenderer,
  We as basicComponentLibrary,
  rt as getResourceMetadata,
  nt as getUIResourceMetadata,
  jt as isUIResource,
  Yt as remoteButtonDefinition,
  Ft as remoteCardDefinition,
  Wt as remoteImageDefinition,
  Vt as remoteStackDefinition,
  Gt as remoteTextDefinition
};
